import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=3f0268a8&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=ts&"
export * from "./terms.vue?vue&type=script&lang=ts&"
import style0 from "./terms.vue?vue&type=style&index=0&id=3f0268a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0268a8",
  null
  
)

export default component.exports